import { Component, OnInit } from '@angular/core';
import { StudentService } from '../../students/shared/student.service';
import { Program } from '../../programs/shared/program.model';
import { ProgramService } from '../../programs/shared/program.service';
import { Route, Router, ActivatedRoute } from '@angular/router';
import { Student } from '../../students/shared/student.model';

@Component({
  selector: 'app-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.scss']
})
export class RequestComponent implements OnInit {
  public loading: boolean;

  constructor(private studentService: StudentService,
              private programService: ProgramService,
              private router: Router,
              private route: ActivatedRoute) {
    this.loading = true;
  }

  ngOnInit() {
    const cedula = localStorage.getItem('cedula');
    this.studentService.getInformatioStudentPrograms(cedula, null).subscribe(
      (result) => {
        if (result.data !== {}) {
         this.prepareRequest(result.data);
        }
      },
      (error) => {
          console.log(error);
      });
  }

  private prepareRequest(dataStudent) {
    if (dataStudent.estudiante !== undefined ) {
      const student: Student  = dataStudent.estudiante ;
      student.programas = dataStudent.programas;
        if (student.programas.length === 1) {
            const program: Program = student.programas[0];
            const cedula = localStorage.getItem('cedula');
            this.validateRecordStudent(cedula, program.codigo, program.version);
        } else {
          this.loading = false;
          this.router.navigate(['estudiante-programas']);
        }
    } else {
      this.loading = false;
      const parameters = {
        tipo: 'error',
        mensaje: 'Usted no es estudiante activo en la Universidad de Antioquia. Comuníquese con Admisiones y Registro'
      };
      this.router.navigate(['message'], {queryParams : parameters});
    }
  }

  private validateRecordStudent(student, programa, version) {
    this.studentService.getStudentRecords(student, programa, null).subscribe(
      (result) => {
        if (result.data.length  === 0) {
          this.validatePifleProgram( programa, version);
        } else {
          this.redirectProgramType(programa, version);
        }
      },
      (error) => {
          console.log(error);
      });
  }

  private validatePifleProgram(programa, version) {
    this.programService.isBelongPifle(programa, version).subscribe(
      (result) => {
        if (result.data) {
         this.redirectProgramType(programa , version);
        } else {
          this.loading = false;
          this.router.navigate(['solicitudes/registro-asignaturas'],
           { queryParams: { programa: programa , tipo: 2 , enableBack : false } });
        }
      },
      (error) => {
          console.log(error);
      });
  }

  private redirectProgramType(programa, version) {
    this.loading = false;
    this.router.navigate(['solicitudes/tipo-disponibles'], { queryParams: { programa: programa , version: version } });
  }
}
